import ReadDelimitedNode from './types/readDelimited';
import ReadExcelNode from './types/readExcel';
import ReadJsonNode from './types/readJson';
import ReadTextNode from './types/readText';
import ReadXmlNode from './types/readXml';
import WriteDelimitedNode from './types/writeDelimited';
import WriteExcelNode from './types/writeExcel';
import WriteJsonArrayNode from './types/writeJsonArray';
import WriteTextNode from './types/writeText';
import WriteXmlNode from './types/writeXml';

export const formatNodes = {
  readformat: {
    excel: ReadExcelNode,
    text: ReadTextNode,
    xml: ReadXmlNode,
    delimited: ReadDelimitedNode,
    json: ReadJsonNode,
  },
  writeformat: {
    excel: WriteExcelNode,
    jsonArray: WriteJsonArrayNode,
    text: WriteTextNode,
    xml: WriteXmlNode,
    delimited: WriteDelimitedNode,
  },
};
